import { graphql } from "relay-runtime"

export const chDuplicatePatientByIdQuery = graphql`
  query chDuplicatePatientByIdQuery($patientId: ID!) {
    ch_patientById(id: $patientId) {
      id
      firstName
      lastName
      gender
      displayId
      contactChannel
      country
      duplicatePatients {
        id
        firstName
        lastName
        gender
        displayId
        contactChannel
      }
    }
  }
`
